<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->

<template>
  <div style="height: 100%">
    <div class="inner">
      <div class="top_tab">
        <div class="tab"
             v-for="(item,index) in tab"
             :key="index"
             @click.stop="tabClick(index)"
             :class="{'activ_tab':tabActive == index}">{{item}}</div>
      </div>
      <div class="top_bar"
           v-if="tabActive == 1">
        <div class="box"
             :class="{'active_bar':active == index}"
             v-for="(item, index) in barList"
             :key="index"
             @click.stop="barClick(index)"
             :style="'background:' + (active == index?item.bgcolor:'') + '!important;'">{{item.names}}</div>
      </div>

      <!-- <div class="big_box"
             @scroll.passive="scroll($event)">
          <van-cell v-for="(item,index) in list"
                    :key="index"
                    :title="item.cate_name"
                    is-link
                    @click.stop="toLink(item.cate_id,item.cate_name)" />
        </div> -->
      <!-- <div> -->
      <div class="big_box_list"
           v-if="tabActive == 1">
        <div class="title_box"
             v-if="barList[active]">{{barList[active].names}}:</div>
        <div class="list_box"
             @scroll.passive="scroll($event)">
             <template v-if="!allShow">
               <div class="boxs"
               @click="toLink(item)"
               v-for="(item,index) in list"
               :key="index">
            <div class="title">{{item.cate_name}}</div>
            <van-icon name="arrow"
                      color="#919191"
                      size="20" />
          </div>
             </template>

          <div
            class="details"
            v-else
          >
            <div
              class="tItems"
              v-for="(item, index) in list1"
              :key="index"
              @click.stop="toDetail(item.instructions_id,item.type)"
            >
              <img :src="item.type == 1 || item.type == 4 ?item.video_page:item.pt_page" />
              <a :id="'title'+ index" />
              <p>{{index + 1}}.{{item.title}}</p>
              <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
            </div>
          </div>
        </div>
      </div>
      <down v-if="tabActive == 1 || show"></down>
    </div>
  </div>
</template>

<script>
import { getWapSeriasList, getWapCateList, getList, getWapList } from '../api/wap'
import store from '@/store/index.js'
import down from '@/components/down'
export default {
  components: {
    down
  },
  data () {
    return {
      barList: [],
      active: 3,
      page: 1,
      page_total: 1,
      list: [],
      imgList: [],
      tab: ['产品介绍', '电机说明'],
      tabActive: 1,
      show: false,
      content: '',
      pageHeight: '',
      allShow: false,
      list1: []
    }
  },
  store,
  created () {
    // console.log(this.$store.state.isOne)
    if (this.$store.state.isOne) {
      if (this.$route.query.xiabiao) this.$store.commit('one', this.$route.query.xiabiao)
    }

    this.active = this.$store.state.active
    this.getBar()
    this.onLoadData()
    // console.log(this.$store.state);
  },
  mounted () {
    // this.pageHeight = 'height:' + document.documentElement.screen.availHeight + 'px !important;'
  },
  methods: {
    barClick (index) {
      if (this.active !== index) {
        this.active = index
        this.page = 1
        this.$store.commit('check', index)
        this.getlist()
      }
    },
    getBar () {
      getWapSeriasList({}).then(res => {
        this.barList = res.result.series_data
        this.getlist()
      })
    },
    getlist () {
      getWapCateList({
        page_now: this.page,
        cate_id: this.barList[this.active].series_id,
        cate_level: 1
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result.lists
          if (res.result.lists.length === 0) {
            this.allShow = true
            this.getAll()
          } else {
            this.allShow = false
          }
        } else {
          this.list.push(...res.result.lists)
        };
        this.page_total = res.result.page_total
      })
    },
    getAll () {
      getWapList({
        page_now: this.page,
        cate_id: this.barList[this.active].series_id,
        cate_level: 0
      }).then(res => {
        if (this.page === 1) {
          this.list1 = res.result
        } else {
          this.list1.push(...res.result)
        }
        // this.page_total = res.result.page_total
      })
    },
    toLink (item) {
      getWapCateList({
        page_now: 1,
        cate_id: item.cate_id,
        cate_level: item.cate_level + 1
      }).then(res => {
        if (res.result.lists.length > 0) {
          localStorage.setItem('lower3', JSON.stringify(res.result.lists[0]))
          this.$router.push({
            path: '/twolevel',
            query: {
              id: item.cate_id,
              index: this.active,
              num: -1,
              cate_level: item.cate_level
            }
          })
        } else {
          this.$router.push({
            path: '/newDetailList',
            query: {
              name: item.cate_name,
              index: this.active,
              id: item.cate_id,
              cate_level: item.cate_level,
              num: -1
            }
          })
        }
      })
    },
    scroll (e) {
      if (this.allShow) return
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    onLoadData () {
      getList({ type: 3 })
        .then(res => {
          this.imgList = res.result.list
        })
    },
    tabClick (index) {
      this.tabActive = index
      if (index === 0) {
        this.$router.push({
          path: '/productIndex'
        })
      }
    },
    onToDetail (e) {
      this.content = e.replace(/<h1/g, "<h1 style='font-size: .32rem !important'")
      this.show = true
    },
    toDetail (id, type) {
      if (type === 2 || type === '2' || type === 5 || type === '5') {
        this.$router.push({
          path: '/videoDetail',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          path: '/directionsDetail',
          query: {
            id: id
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.big_box_list {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.list_box {
  padding: 0.28rem 0.48rem 0;
  flex: 1;
  overflow-y: auto;
}
.boxs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  box-shadow: 0px 0px 0.46rem 0px rgba(0, 0, 0, 0.13);
  margin-bottom: 0.26rem;
  min-height: 1.5rem;
  border-radius: 0.16rem;
}
.title {
  width: 5.45rem;
  font-size: 0.42rem;
  color: #121212;
  font-weight: 500;
  line-height: 0.5rem;
}
.inner {
  width: 100%;
  /* height: 100vh; */
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
}
.top_tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #1f1402;
  flex-shrink: 0;
}
.tab {
  flex: 1;
  text-align: center;
  font-size: 0.32rem;
  line-height: 1.06rem;
  color: #999;
}
.activ_tab {
  color: #fff;
}
.top_bar {
  padding: 0.2rem 0.5rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.box {
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a4a4a;
  border: 1px solid #4a4a4a;
  font-size: 0.28rem;
  white-space: wrap;
  border-radius: 0.1rem;
}
.active_bar {
  color: #fff !important;
  border: none !important;
}
.title_box {
  line-height: 0.7rem;
  font-size: 0.28rem;
  padding-left: 0.4rem;
  flex-shrink: 0;
}
.big_box {
  flex: 1;
  overflow: auto;
}
.big_box >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.productList img {
  margin-top: 0.3rem;
  width: 100%;
  border-radius: 0.16rem;
}
.productList {
  padding: 0 0.2rem;
}
.describe {
  padding: 0 0.2rem;
  font-size: 0.28rem;
}
.details {
  padding: 0 0.1rem 0;
  /* display: flex;
  flex-wrap: wrap; */
  /* background: #fff; */
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(calc(100% - 0.2rem) / 2));
  gap: 0.3rem 0.2rem;
}
.tItems {
  /* margin-bottom: 0.3rem;
  width: 3.45rem; */
  width: 100%;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  /* margin-left: 0.1rem;
  margin-right: 0.1rem; */
  padding-bottom: 0.2rem;
}
.tItems p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItems img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
</style>
